import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';

@Injectable()
export class ErrorService {
  public errorMessages = new ReplaySubject<string[]>(1);
  public warningMessages = new ReplaySubject<string[]>(1);
  private _errorSet = new Set<string>();
  private _warningSet = new Set<string>();

  public pushErrorMessage(message: string) {
    if (!message) {
      return;
    }
    this._errorSet.add(message);
    this.errorMessages.next(Array.from(this._errorSet));
  }

  public clearErrors() {
    this._errorSet.clear();
    this.errorMessages.next(Array.from(this._errorSet));
  }

  public pushWarningMessage(message: string) {
    if (!message) {
      return;
    }
    this._warningSet.add(message);
    this.warningMessages.next(Array.from(this._warningSet));
  }

  public clearWarnings() {
    this._warningSet.clear();
    this.warningMessages.next(Array.from(this._warningSet));
  }
}
